// user results
export const FETCH_USER_RESULTS_REQUEST = 'FETCH_USER_RESULTS_REQUEST';
export const FETCH_USER_RESULTS_SUCCESS = 'FETCH_USER_RESULTS_SUCCESS';
export const FETCH_USER_RESULTS_FAILURE = 'FETCH_USER_RESULTS_FAILURE';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SIGNUP_FAIL = 'SIGNUP_FAIL';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const PARTICIPANT_SIGNUP_FAIL = 'PARTICIPANT_SIGNUP_FAIL';
export const PARTICIPANT_SIGNUP_SUCCESS = 'PARTICIPANT_SIGNUP_SUCCESS';
export const GET_ERRORS = 'GET_ERRORS';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const FETCH_TRINER_RESULTS_REQUEST = 'FETCH_TRINER_RESULTS_REQUEST';
export const FETCH_TRINER_RESULTS_SUCCESS = 'FETCH_TRINER_RESULTS_SUCCESS';
export const FETCH_TRINER_RESULTS_FAILURE = 'FETCH_TRINER_RESULTS_FAILURE';
export const FETCH_ALL_TRAINERS = 'FETCH_ALL_TRAINERS';
export const ADD_SESSION_SUCCESS = 'ADD_SESSION_SUCCESS';
export const ADD_SESSION_FAIL = 'ADD_SESSION_FAIL';
export const RESET_SESSION_STATE = 'RESET_SESSION_STATE';
export const FETCH_LOCAL_LEADS = 'FETCH_LOCAL_LEADS';
export const CHECK_UNIQUE_EMAIL_UNIQUE = 'CHECK_UNIQUE_EMAIL_UNIQUE';
export const CHECK_UNIQUE_EMAIL_UNUNIQUE = 'CHECK_UNIQUE_EMAIL_UNUNIQUE';
export const FETCH_STATS = 'FETCH_STATS';
export const USER_AUTHENTICATED = 'USER_AUTHENTICATED';
export const USER_UNAUTHENTICATED = 'USER_UNAUTHENTICATED';
export const FETCH_TRAINERS_SESSIONS = 'FETCH_TRAINERS_SESSIONS';
export const FETCH_LOCAL_LEAD_SESSIONS = 'FETCH_LOCAL_LEAD_SESSIONS';
export const FETCH_ALL_SESSIONS = 'FETCH_ALL_SESSIONS';
export const FETCH_SESSION_DETAILS = 'FETCH_SESSION_DETAILS';
export const DELETE_SESSION_SUCCESS = 'DELETE_SESSION_SUCCESS';
export const EDIT_SESSION_SUCCESS = 'EDIT_SESSION_SUCCESS';
export const UPDATE_EMAILS_SUCCESS = 'UPDATE_EMAILS_SUCCESS';
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const ADD_USER_FAIL = 'ADD_USER_FAIL';
export const ADD_TRAINER_TO_GROUP_SUCCESS = 'ADD_TRAINER_TO_GROUP_SUCCESS';
export const ADD_TRAINER_TO_GROUP_FAIL = 'ADD_TRAINER_TO_GROUP_FAIL';
export const UPGRADE_PARTICIPANT_SUCCESS = 'UPGRADE_PARTICIPANT_SUCCESS';
export const UPGRADE_PARTICIPANT_FAIL = 'UPGRADE_PARTICIPANT_FAIL';
export const RESET_GROUPS_STATE = 'RESET_GROUPS_STATE';
export const RESET_UNIQUE_EMAIL = 'RESET_UNIQUE_EMAIL';
export const CHECK_UNIQUE_EMAIL_ERROR = 'CHECK_UNIQUE_EMAIL_ERROR';
export const UPDATE_VIEW_LEVEL = 'UPDATE_VIEW_LEVEL';
export const FETCH_LOCAL_LEAD_TRAINERS_GROUP =
  'FETCH_LOCAL_LEAD_TRAINERS_GROUP';
export const SEND_SURVEY_EMAIL_SUCCESS = 'SEND_SURVEY_EMAIL_SUCCESS';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAIL = '  CHANGE_PASSWORD_FAIL';

export const FETCH_PRTICIPENT_SESSIONS_REQUEST =
  'FETCH_PRTICIPENT_SESSIONS_REQUEST';
export const FETCH_PARTICIPANT_SESSIONS_SUCCESS =
  'FETCH_PRTICIPENT_SESSIONS_SUCCESS';

export const FETCH_PARTICIPANT_SESSIONS_BY_EMAIL_SUCCESS =
  'FETCH_PARTICIPANT_SESSIONS_BY_EMAIL_SUCCESS';

export const FETCH_PRTICIPENT_SESSIONS_FAILURE =
  'FETCH_PRTICIPENT_SESSIONS_FAILURE';
export const LOGOUT = 'LOGOUT';

export const EXPORT_DATA_SUCCESS = 'EXPORT_DATA_SUCCESS';
export const GET_PARTICIPANTS_DEMOGRAPHIC_SUCCESS =
  'GET_PARTICIPANTS_DEMOGRAPHIC_SUCCESS';
export const GET_PARTICIPANT_SURVEY_RESPONSES_SUCCESS =
  'GET_PARTICIPANT_SURVEY_RESPONSES_SUCCESS';
export const CHECK_USER_BY_EMAIL_SUCCESS = 'CHECK_USER_BY_EMAIL_SUCCESS';
export const CHECK_USER_BY_EMAIL_FAIL = 'CHECK_USER_BY_EMAIL_FAIL';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAIL = 'RESET_PASSWORD_FAIL';
export const FETCH_SESSIONS_PER_REGIONS = 'FETCH_SESSIONS_PER_REGIONS';

export const FETCH_SURVEY_DATA = 'FETCH_SURVEY_DATA';
export const FETCH_SURVEY_DATA_FAIL = 'FETCH_SURVEY_DATA_FAIL';
export const SURVEY_SUBMISSION_SUCCESS = 'SURVEY_SUBMISSION_SUCCESS';
export const SURVEY_SUBMISSION_FAIL = 'SURVEY_SUBMISSION_FAIL';
export const GET_SESSION_DETAILS_BY_SHORT_ID =
  'GET_SESSION_DETAILS_BY_SHORT_ID';
export const CONFIRM_REGISTRATION_ERROR = 'CONFIRM_REGISTRATION_ERROR';
export const CONFIRM_REGISTRATION_SUCCESS = 'CONFIRM_REGISTRATION_SUCCESS';
export const UPDATE_ATTENDEES_SUCCESS = 'UPDATE_ATTENDEES_SUCCESS';
export const UPDATE_ATTENDEES_FAIL = 'UPDATE_ATTENDEES_FAIL';
export const GET_PARTICIPANT_SURVEY_RESPONSES_FAIL =
  'GET_PARTICIPANT_SURVEY_RESPONSES_FAIL';
export const LOADING_START = 'LOADING_START';
export const LOADING_END = 'LOADING_END';
export const EMAIL_SCHEDULE_SUCCESS = 'EMAIL_SCHEDULE_SUCCESS';
export const STORE_SESSION_DATA = 'STORE_SESSION_DATA';
export const CHECK_BROWSER_WIDTH = 'CHECK_BROWSER_WIDTH';
export const LOADING_TRUE = 'LOADING_TRUE';
export const LOADING_FALSE = 'LOADING_FALSE';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const FETCH_ALL_MANAGERS = 'FETCH_ALL_MANAGERS';
export const CLEAR_SESSION_DATA = 'CLEAR_SESSION_DATA';
export const SET_FILTERS = 'SET_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const FETCH_PARTICIPANT_SESSION_DETAILS =
  'FETCH_PARTICIPANT_SESSION_DETAILS';
export const FETCH_PARTICIPANT_SESSION_DETAILS_SUCCESS =
  'FETCH_PARTICIPANT_SESSION_DETAILS_SUCCESS';
export const FETCH_PARTICIPANT_SESSION_DETAILS_FAIL =
  'FETCH_PARTICIPANT_SESSION_DETAILS_FAIL';
export const FETCH_PARTICIPANT_RESPONSES_SUCCESS =
  'FETCH_PARTICIPANT_RESPONSES_SUCCESS';
export const FETCH_PARTICIPANT_RESPONSES_FAIL =
  'FETCH_PARTICIPANT_RESPONSES_FAIL';
export const UPDATE_MY_ACCOUNT_SUCCESS = 'UPDATE_MY_ACCOUNT_SUCCESS';
export const UPDATE_MY_ACCOUNT_FAIL = 'UPDATE_MY_ACCOUNT_FAIL';
export const SELECT_ROLE_SUCCESS = 'SELECT_ROLE_SUCCESS';
export const RESET_ROLE_SUCCESS = 'RESET_ROLE_SUCCESS';
export const SELECT_ROLE_FAIL = 'SELECT_ROLE_FAIL';
export const SIGNUP_TTT_SUCCESS = 'SIGNUP_TTT_SUCCESS';
export const SIGNUP_TTT_FAIL = 'SIGNUP_TTT_FAIL';
export const RESET_SURVEY = 'RESET_SURVEY';
export const FETCH_TRAINER_REFLECTION_SURVEY_SUCCESS =
  'FETCH_TRAINER_REFLECTION_SURVEY_SUCCESS';
export const FETCH_TRAINER_REFLECTION_SURVEY_FAIL =
  'FETCH_TRAINER_REFLECTION_SURVEY_FAIL';
export const TRAINER_REFLECTION_EXISTS = 'TRAINER_REFLECTION_EXISTS';
export const SUBMIT_TRAINER_REFLECTION_START =
  'SUBMIT_TRAINER_REFLECTION_START';
export const SUBMIT_TRAINER_REFLECTION_SUCCESS =
  'SUBMIT_TRAINER_REFLECTION_SUCCESS';
export const SUBMIT_TRAINER_REFLECTION_FAIL = 'SUBMIT_TRAINER_REFLECTION_FAIL';
export const RESET_TRAINER_REFLECTION = 'RESET_TRAINER_REFLECTION';
export const REMOVE_REGISTRATION_SUCCESS = 'REMOVE_REGISTRATION_SUCCESS';
export const REMOVE_REGISTRATION_FAIL = 'REMOVE_REGISTRATION_FAIL';
export const REMOVE_REGISTRATION_LOADING = 'REMOVE_REGISTRATION_LOADING';
export const REMOVE_REGISTRATION_RESET = 'REMOVE_REGISTRATION_RESET';
export const FETCH_PARTICIPANTS_SUCCESS = 'FETCH_PARTICIPANTS_SUCCESS';
